// src/components/pages/LabsBottomCarousel.jsx (adjust path as needed)
import React, { useMemo } from 'react';
import CrossfadeCarousel from './CrossfadeCarousel'; // if this file sits under .../pages/

export default function LabsBottomCarousel() {
  const slides = useMemo(
    () => [
      { src: `${process.env.PUBLIC_URL}/images/labs/labs bottom carousel/labs 2.1.jpg`, alt: 'Labs 2.1' },
      { src: `${process.env.PUBLIC_URL}/images/labs/labs bottom carousel/labs 2.2.jpg`, alt: 'Labs 2.2' },
      { src: `${process.env.PUBLIC_URL}/images/labs/labs bottom carousel/labs 2.3.jpg`, alt: 'Labs 2.3' },
      { src: `${process.env.PUBLIC_URL}/images/labs/labs bottom carousel/labs 2.4.jpg`, alt: 'Labs 2.4' },
      { src: `${process.env.PUBLIC_URL}/images/labs/labs bottom carousel/labs 2.5.jpg`, alt: 'Labs 2.5' },
      { src: `${process.env.PUBLIC_URL}/images/labs/labs bottom carousel/labs 2.6.jpg`, alt: 'Labs 2.6' },
    ],
    []
  );

  return (
    <CrossfadeCarousel
      slides={slides}
    />
  );
}
